import { Helmet } from 'react-helmet-async';
import Transitions from "../../../components/dashboard/transitions/Transitions"

export default function TransitionsHome() {
    return (
        <>
          <Helmet>
            <title>Transitions | Platform Solutions</title>
          </Helmet>
          <Transitions/>
        </>
    );
}